import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.min.css';
import "src/assets/css/fullapp.css";
import "src/assets/css/dashboard.css";
import "src/assets/css/overwrite.css";
import "src/assets/css/datatable.css";

<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"></link>

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)
reportWebVitals()
